import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=56f57491&"
import script from "./IconUser.vue?vue&type=script&lang=js&"
export * from "./IconUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f57491')) {
      api.createRecord('56f57491', component.options)
    } else {
      api.reload('56f57491', component.options)
    }
    module.hot.accept("./IconUser.vue?vue&type=template&id=56f57491&", function () {
      api.rerender('56f57491', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUser.vue"
export default component.exports